import { style } from '@vanilla-extract/css'

const section = style({
  background: `
    linear-gradient(148.21deg, rgba(244, 228, 213, 0.9) 11.73%, rgba(248, 232, 238, 0.9) 27.56%, rgba(209, 227, 244, 0.54) 56.26%, rgba(195, 232, 239, 0) 76.14%),
    linear-gradient(180.01deg, rgba(242, 241, 239, 0) 40.8%, #F2F1EF 99.99%);
  `,
})

const card = style({
  borderRadius: '16px',
  backgroundColor: 'white',
  selectors: {
    '&::details-content': {
      contentVisibility: 'unset',
      display: 'block grid',
      transitionDuration: '300ms',
      transitionProperty: 'grid-template-rows',
      transitionTimingFunction: 'ease-out',
    },
    '&:not([open])::details-content': {
      gridTemplateRows: '0fr',
    },
    '&[open]::details-content': {
      gridTemplateRows: '1fr',
    },
  },
})

const planLabel = style({
  backgroundColor: '#ECEBE9',
  padding: '2px 12px',
  borderRadius: '48px',
  fontWeight: '700',
  fontSize: '15px',
  lineHeight: '1.5',
})

const planPrice = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  color: '#E46327',
  fontWeight: '700',
  fontSize: '28px',
  lineHeight: '1.5',
})

const planDelivery = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#858585',
})

const planKey = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const planValue = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const note = style({
  color: '#828282',
  fontSize: '12px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const cool = style({
  width: '12px',
  height: '18px',
  color: '#828282',
})

const summary = style({
  padding: '16px',
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  cursor: 'pointer',
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  selectors: {
    '&::-webkit-details-marker': {
      display: 'none',
    },
  },
})

const caret = style({
  width: '16px',
  height: '16px',
})

const cardContent = style({
  overflow: 'hidden',
  padding: '0 16px',
})

const divider = style({
  backgroundImage: 'linear-gradient(to right, #DEDCD7, #DEDCD7 3px, transparent 3px)',
  backgroundSize: '8px 1px',
  backgroundRepeat: 'repeat-x',
  backgroundPosition: 'center',
  border: 'none',
  height: '1px',
})

const text = style({
  padding: '16px 0',
  fontSize: '15px',
  lineHeight: '1.5',
})

export const styles = {
  section,
  card,
  planLabel,
  planPrice,
  planDelivery,
  planKey,
  planValue,
  note,
  cool,
  caret,
  cardContent,
  summary,
  divider,
  text,
}
